import { z } from "zod";
export const CountryCodeDictionary = {
    AF: "Afghanistan",
    AX: "Åland Islands",
    AL: "Albania",
    DZ: "Algeria",
    AS: "American Samoa",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antarctica",
    AG: "Antigua and Barbuda",
    AR: "Argentina",
    AM: "Armenia",
    AW: "Aruba",
    AU: "Australia",
    AT: "Austria",
    AZ: "Azerbaijan",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgium",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    BT: "Bhutan",
    BO: "Bolivia, Plurinational State of",
    BQ: "Bonaire, Sint Eustatius and Saba",
    BA: "Bosnia and Herzegovina",
    BW: "Botswana",
    BV: "Bouvet Island",
    BR: "Brazil",
    IO: "British Indian Ocean Territory",
    BN: "Brunei Darussalam",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Cambodia",
    CM: "Cameroon",
    CA: "Canada",
    CV: "Cape Verde",
    KY: "Cayman Islands",
    CF: "Central African Republic",
    TD: "Chad",
    CL: "Chile",
    CN: "China",
    CX: "Christmas Island",
    CC: "Cocos (Keeling) Islands",
    CO: "Colombia",
    KM: "Comoros",
    CG: "Congo",
    CD: "Congo, the Democratic Republic of the",
    CK: "Cook Islands",
    CR: "Costa Rica",
    CI: "Côte d'Ivoire",
    HR: "Croatia",
    CU: "Cuba",
    CW: "Curaçao",
    CY: "Cyprus",
    CZ: "Czech Republic",
    DK: "Denmark",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Dominican Republic",
    EC: "Ecuador",
    EG: "Egypt",
    SV: "El Salvador",
    GQ: "Equatorial Guinea",
    ER: "Eritrea",
    EE: "Estonia",
    ET: "Ethiopia",
    FK: "Falkland Islands (Malvinas)",
    FO: "Faroe Islands",
    FJ: "Fiji",
    FI: "Finland",
    FR: "France",
    GF: "French Guiana",
    PF: "French Polynesia",
    TF: "French Southern Territories",
    GA: "Gabon",
    GM: "Gambia",
    GE: "Georgia",
    DE: "Germany",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Greece",
    GL: "Greenland",
    GD: "Grenada",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernsey",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HM: "Heard Island and McDonald Mcdonald Islands",
    VA: "Holy See (Vatican City State)",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hungary",
    IS: "Iceland",
    IN: "India",
    ID: "Indonesia",
    IR: "Iran, Islamic Republic of",
    IQ: "Iraq",
    IE: "Ireland",
    IM: "Isle of Man",
    IL: "Israel",
    IT: "Italy",
    JM: "Jamaica",
    JP: "Japan",
    JE: "Jersey",
    JO: "Jordan",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    XK: "Kosovo",
    KP: "Korea, Democratic People's Republic of",
    KR: "Korea, Republic of",
    KW: "Kuwait",
    KG: "Kyrgyzstan",
    LA: "Lao People's Democratic Republic",
    LV: "Latvia",
    LB: "Lebanon",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Libya",
    LI: "Liechtenstein",
    LT: "Lithuania",
    LU: "Luxembourg",
    MO: "Macao",
    MK: "Macedonia, the Former Yugoslav Republic of",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malta",
    MH: "Marshall Islands",
    MQ: "Martinique",
    MR: "Mauritania",
    MU: "Mauritius",
    YT: "Mayotte",
    MX: "Mexico",
    FM: "Micronesia, Federated States of",
    MD: "Moldova, Republic of",
    MC: "Monaco",
    MN: "Mongolia",
    ME: "Montenegro",
    MS: "Montserrat",
    MA: "Morocco",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: "Netherlands",
    AN: "Netherlands Antilles",
    NC: "New Caledonia",
    NZ: "New Zealand",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    NF: "Norfolk Island",
    MP: "Northern Mariana Islands",
    NO: "Norway",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palau",
    PS: "Palestine, State of",
    PA: "Panama",
    PG: "Papua New Guinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippines",
    PN: "Pitcairn",
    PL: "Poland",
    PT: "Portugal",
    PR: "Puerto Rico",
    QA: "Qatar",
    RE: "Réunion",
    RO: "Romania",
    RU: "Russian Federation",
    RW: "Rwanda",
    BL: "Saint Barthélemy",
    SH: "Saint Helena, Ascension and Tristan da Cunha",
    KN: "Saint Kitts and Nevis",
    LC: "Saint Lucia",
    MF: "Saint Martin (French part)",
    PM: "Saint Pierre and Miquelon",
    VC: "Saint Vincent and the Grenadines",
    WS: "Samoa",
    SM: "San Marino",
    ST: "Sao Tome and Principe",
    SA: "Saudi Arabia",
    SN: "Senegal",
    RS: "Serbia",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapore",
    SX: "Sint Maarten (Dutch part)",
    SK: "Slovakia",
    SI: "Slovenia",
    SB: "Solomon Islands",
    SO: "Somalia",
    ZA: "South Africa",
    GS: "South Georgia and the South Sandwich Islands",
    SS: "South Sudan",
    ES: "Spain",
    LK: "Sri Lanka",
    SD: "Sudan",
    SR: "Suriname",
    SJ: "Svalbard and Jan Mayen",
    SZ: "Swaziland",
    SE: "Sweden",
    CH: "Switzerland",
    SY: "Syrian Arab Republic",
    TW: "Taiwan, Province of China",
    TJ: "Tajikistan",
    TZ: "Tanzania, United Republic of",
    TH: "Thailand",
    TL: "Timor-Leste",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad and Tobago",
    TN: "Tunisia",
    TR: "Turkey",
    TM: "Turkmenistan",
    TC: "Turks and Caicos Islands",
    TV: "Tuvalu",
    UG: "Uganda",
    UA: "Ukraine",
    AE: "United Arab Emirates",
    GB: "United Kingdom",
    US: "United States",
    UM: "United States Minor Outlying Islands",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VU: "Vanuatu",
    VE: "Venezuela, Bolivarian Republic of",
    VN: "Viet Nam",
    VG: "Virgin Islands, British",
    VI: "Virgin Islands, U.S.",
    WF: "Wallis and Futuna",
    EH: "Western Sahara",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabwe",
};
export const CountryTypeZ = z.enum(Object.keys(CountryCodeDictionary));
// Canonical nationality labels from GOV.UK's "List of nationalities".
// Labels which cannot be mapped uniquely to a country code are intentionally
// omitted (for example, Stateless and the regional UK nationalities).
export const nationalityCodeDictionary = {
    AF: "Afghan",
    AL: "Albanian",
    DZ: "Algerian",
    US: "American",
    AD: "Andorran",
    AO: "Angolan",
    AI: "Anguillan",
    AG: "Citizen of Antigua and Barbuda",
    AR: "Argentine",
    AM: "Armenian",
    AU: "Australian",
    AT: "Austrian",
    AZ: "Azerbaijani",
    BS: "Bahamian",
    BH: "Bahraini",
    BD: "Bangladeshi",
    BB: "Barbadian",
    BY: "Belarusian",
    BE: "Belgian",
    BZ: "Belizean",
    BJ: "Beninese",
    BM: "Bermudian",
    BT: "Bhutanese",
    BO: "Bolivian",
    BA: "Citizen of Bosnia and Herzegovina",
    BW: "Botswanan",
    BR: "Brazilian",
    GB: "British",
    VG: "British Virgin Islander",
    BN: "Bruneian",
    BG: "Bulgarian",
    BF: "Burkinan",
    MM: "Burmese",
    BI: "Burundian",
    KH: "Cambodian",
    CM: "Cameroonian",
    CA: "Canadian",
    CV: "Cape Verdean",
    KY: "Cayman Islander",
    CF: "Central African",
    TD: "Chadian",
    CL: "Chilean",
    CN: "Chinese",
    CO: "Colombian",
    KM: "Comoran",
    CG: "Congolese (Congo)",
    CD: "Congolese (DRC)",
    CK: "Cook Islander",
    CR: "Costa Rican",
    HR: "Croatian",
    CU: "Cuban",
    CY: "Cypriot",
    CZ: "Czech",
    DK: "Danish",
    DJ: "Djiboutian",
    DM: "Dominican",
    DO: "Citizen of the Dominican Republic",
    NL: "Dutch",
    TL: "East Timorese",
    EC: "Ecuadorean",
    EG: "Egyptian",
    AE: "Emirati",
    GQ: "Equatorial Guinean",
    ER: "Eritrean",
    EE: "Estonian",
    ET: "Ethiopian",
    FO: "Faroese",
    FJ: "Fijian",
    PH: "Filipino",
    FI: "Finnish",
    FR: "French",
    GA: "Gabonese",
    GM: "Gambian",
    GE: "Georgian",
    DE: "German",
    GH: "Ghanaian",
    GI: "Gibraltarian",
    GR: "Greek",
    GL: "Greenlandic",
    GD: "Grenadian",
    GU: "Guamanian",
    GT: "Guatemalan",
    GW: "Citizen of Guinea-Bissau",
    GN: "Guinean",
    GY: "Guyanese",
    HT: "Haitian",
    HN: "Honduran",
    HK: "Hong Konger",
    HU: "Hungarian",
    IS: "Icelandic",
    IN: "Indian",
    ID: "Indonesian",
    IR: "Iranian",
    IQ: "Iraqi",
    IE: "Irish",
    IL: "Israeli",
    IT: "Italian",
    CI: "Ivorian",
    JM: "Jamaican",
    JP: "Japanese",
    JO: "Jordanian",
    KZ: "Kazakh",
    KE: "Kenyan",
    KN: "Kittitian",
    KI: "Citizen of Kiribati",
    XK: "Kosovan",
    KW: "Kuwaiti",
    KG: "Kyrgyz",
    LA: "Lao",
    LV: "Latvian",
    LB: "Lebanese",
    LR: "Liberian",
    LY: "Libyan",
    LI: "Liechtenstein citizen",
    LT: "Lithuanian",
    LU: "Luxembourger",
    MO: "Macanese",
    MK: "Macedonian",
    MG: "Malagasy",
    MW: "Malawian",
    MY: "Malaysian",
    MV: "Maldivian",
    ML: "Malian",
    MT: "Maltese",
    MH: "Marshallese",
    MQ: "Martiniquais",
    MR: "Mauritanian",
    MU: "Mauritian",
    MX: "Mexican",
    FM: "Micronesian",
    MD: "Moldovan",
    MC: "Monegasque",
    MN: "Mongolian",
    ME: "Montenegrin",
    MS: "Montserratian",
    MA: "Moroccan",
    LS: "Mosotho",
    MZ: "Mozambican",
    NA: "Namibian",
    NR: "Nauruan",
    NP: "Nepalese",
    NZ: "New Zealander",
    NI: "Nicaraguan",
    NG: "Nigerian",
    NE: "Nigerien",
    NU: "Niuean",
    KP: "North Korean",
    NO: "Norwegian",
    OM: "Omani",
    PK: "Pakistani",
    PW: "Palauan",
    PS: "Palestinian",
    PA: "Panamanian",
    PG: "Papua New Guinean",
    PY: "Paraguayan",
    PE: "Peruvian",
    PN: "Pitcairn Islander",
    PL: "Polish",
    PT: "Portuguese",
    PR: "Puerto Rican",
    QA: "Qatari",
    RO: "Romanian",
    RU: "Russian",
    RW: "Rwandan",
    SV: "Salvadorean",
    SM: "Sammarinese",
    WS: "Samoan",
    ST: "Sao Tomean",
    SA: "Saudi Arabian",
    SN: "Senegalese",
    RS: "Serbian",
    SC: "Citizen of Seychelles",
    SL: "Sierra Leonean",
    SG: "Singaporean",
    SK: "Slovak",
    SI: "Slovenian",
    SB: "Solomon Islander",
    SO: "Somali",
    ZA: "South African",
    KR: "South Korean",
    SS: "South Sudanese",
    ES: "Spanish",
    LK: "Sri Lankan",
    SH: "St Helenian",
    LC: "St Lucian",
    SD: "Sudanese",
    SR: "Surinamese",
    SZ: "Swazi",
    SE: "Swedish",
    CH: "Swiss",
    SY: "Syrian",
    TW: "Taiwanese",
    TJ: "Tajik",
    TZ: "Tanzanian",
    TH: "Thai",
    TG: "Togolese",
    TO: "Tongan",
    TT: "Trinidadian",
    TN: "Tunisian",
    TR: "Turkish",
    TM: "Turkmen",
    TC: "Turks and Caicos Islander",
    TV: "Tuvaluan",
    UG: "Ugandan",
    UA: "Ukrainian",
    UY: "Uruguayan",
    UZ: "Uzbek",
    VA: "Vatican citizen",
    VU: "Citizen of Vanuatu",
    VE: "Venezuelan",
    VN: "Vietnamese",
    VC: "Vincentian",
    WF: "Wallisian",
    YE: "Yemeni",
    ZM: "Zambian",
    ZW: "Zimbabwean",
};
export const NationalityCodeZ = z.enum(Object.keys(nationalityCodeDictionary));
//# sourceMappingURL=types.js.map